/**
 * Is a card title "one URL"? The server decides (it creates the preview); this mirror lets the
 * tile leave preview mode IMMEDIATELY when the title stops being a single link, before the
 * response of the rename arrives. Mirrors backend `app/cards/link_url.py` (without normalizing).
 */
export function isSingleUrl(title: string): boolean {
  const value = title.trim();
  if (value === '' || /\s/.test(value)) return false;
  try {
    const url = new URL(value);
    return (
      (url.protocol === 'http:' || url.protocol === 'https:') &&
      url.hostname !== '' &&
      url.username === '' &&
      url.password === ''
    );
  } catch {
    return false;
  }
}
